<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <ul class="nav metismenu" id="side-menu">
      <li class="nav-header">
        <img src="/static/logo-my-emateriel.svg" />
      </li>
      <li class="mobile-nav-header">
        <div class="nav-toggle" @click="hideMobileMenu()">
          <i class="far fa-bars fa-lg"></i>
        </div>
        <router-link :to="{ name: 'Logout' }">
          Déconnexion
          <i class="far fa-times"></i>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isHome }">
        <router-link :to="{ name: 'Home' }">
          <i class="fas fa-th-large"></i>
          <span class="nav-label">Dashboard</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isRenting }" v-show="$root.isAuthorized('renting_index')">
        <router-link :to="{ name: 'RentingList' }">
          <i class="far fa-long-arrow-right"></i>
          <span class="nav-label">Commandes</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isRentingPreparation }" v-show="$root.isAuthorized('renting-preparation_index')">
        <router-link :to="{ name: 'RentingPreparationList' }">
          <i class="far fa-long-arrow-alt-right"></i>
          <span class="nav-label">Préparations</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isBusinessReturn }" v-show="$root.isAuthorized('business-return_index')">
        <router-link :to="{ name: 'BusinessReturnList' }">
          <i class="far fa-long-arrow-left"></i>
          <span class="nav-label">Retours</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isExchange }" v-show="$root.isAuthorized('exchange_index')">
        <router-link :to="{ name: 'ExchangeList' }">
          <i class="far fa-exchange"></i>
          <span class="nav-label">Échanges</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isTransfer }" v-show="$root.isAuthorized('transfer_index')">
        <router-link :to="{ name: 'TransferList' }">
          <i class="far fa-exchange"></i>
          <span class="nav-label">Transferts</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isShipping }" v-show="$root.isAuthorized('shipping_index')">
        <router-link :to="{ name: 'ShippingList' }">
          <i class="far fa-truck"></i>
          <span class="nav-label">Expéditions</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isStorageMenu }" v-show="$root.isAuthorized(
          ['warehouse_index', 'warehouse-transfer_index', 'department-warehouse_index', 'category-warehouse_index', 'storage-zone_index', 'storage-environment_index'],
          true
        )
          ">
        <a href="#" aria-expanded="true">
          <i class="far fa-warehouse"></i>
          <span class="nav-label">Entrepôt</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isStorageMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isWarehouse }" v-show="$root.isAuthorized('warehouse_index')">
            <router-link :to="{ name: 'WarehouseList' }">Entrepôts</router-link>
          </li>
          <li :class="{ active: isStorageZone }" v-show="$root.isAuthorized('storage-zone_index')">
            <router-link :to="{ name: 'StorageZoneList' }">Zones de stockage</router-link>
          </li>
          <li :class="{ active: isStorageEnvironment }" v-show="$root.isAuthorized('storage-environment_index')">
            <router-link :to="{ name: 'StorageEnvironmentList' }">Environnements de stockage</router-link>
          </li>
          <li :class="{ active: $route.name === 'CategoryWarehouseList' }" v-show="$root.isAuthorized('category-warehouse_index')">
            <router-link :to="{ name: 'CategoryWarehouseList' }">Visibilité par catégorie</router-link>
          </li>
          <li :class="{ active: $route.name === 'DepartmentWarehouseList' }" v-show="$root.isAuthorized('department-warehouse_index')">
            <router-link :to="{ name: 'DepartmentWarehouseList' }">Affectation par département</router-link>
          </li>
          <li :class="{ active: isWarehouseTransfer }" v-show="$root.isAuthorized('warehouse-transfer_index')">
            <router-link :to="{ name: 'WarehouseTransferList' }">Transferts inter-entrepôts</router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isEquipmentMenu }"
        v-show="$root.isAuthorized(['product_index', 'reference_index', 'spare-part_index'], true)">
        <a href="#" aria-expanded="true">
          <i class="far fa-toolbox"></i>
          <span class="nav-label">Materiel</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isEquipmentMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isProduct }" v-show="$root.isAuthorized('product_index')">
            <router-link :to="{ name: 'ProductList' }">Produits</router-link>
          </li>
          <li :class="{ active: isParentProduct }" v-show="$root.isAuthorized('product_index')">
            <router-link :to="{ name: 'ParentProductList' }">Produits spéciaux</router-link>
          </li>
          <li :class="{ active: isReference }" v-show="$root.isAuthorized('reference_index')">
            <router-link :to="{ name: 'ReferenceList' }">Références uniques</router-link>
          </li>
          <li :class="{ active: isSparePart }" v-show="$root.isAuthorized('spare-part_index')">
            <router-link :to="{ name: 'SparePartList' }">Pièces de rechange</router-link>
          </li>
          <li :class="{ active: isAgencyRentingsList }" v-show="$root.isAuthorized('reference_index')">
            <router-link :to="{ name: 'AgencyRentingsList' }">Locations agences</router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isExternalMaintenance || isOverdueMaintenanceReference }"
        v-show="$root.isAuthorized('external-maintenance_index')">
        <a href="#" aria-expanded="true">
          <i class="far fa-wrench"></i>
          <span class="nav-label">Maintenance</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="[
          'nav',
          'nav-second-level',
          'collapse',
          isExternalMaintenance || isOverdueMaintenanceReference ? 'in' : null,
        ]" aria-expanded="true" style>
          <li :class="{ active: isExternalMaintenance }" v-show="$root.isAuthorized('external-maintenance_index')">
            <router-link :to="{ name: 'ExternalMaintenanceList' }">Contrôles et réparations</router-link>
          </li>
          <li :class="{ active: isOverdueMaintenanceReference }" v-show="$root.isAuthorized('reference_index')">
            <router-link :to="{ name: 'OverdueMaintenanceReferenceList' }">Matériel à contrôler</router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isCompanyMenu }" v-show="$root.isAuthorized(
          ['company_index', 'company-contact_index', 'company-group_index'],
          true
        )
          ">
        <a href="#" aria-expanded="true">
          <i class="far fa-building"></i>
          <span class="nav-label">Entreprises</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isCompanyMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isCompany }" v-show="$root.isAuthorized('company_index')">
            <router-link :to="{ name: 'CompanyList' }">Entreprises</router-link>
          </li>
          <li :class="{ active: isCompanyContact }" v-show="$root.isAuthorized('company-contact_index')">
            <router-link :to="{ name: 'CompanyContactList' }">Contacts</router-link>
          </li>
          <li :class="{ active: isCompanyGroup }" v-show="$root.isAuthorized('company-group_index')">
            <router-link :to="{ name: 'CompanyGroupList' }">Familles d'entreprises</router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isBillingMenu }" v-show="$root.isAuthorized(
          ['internal-billing_index', 'manual-billing_index', 'not-billable-business_index',
           'transport-rate_index', 'location-for-account_index'],
          true
        )
          ">
        <a href="#" aria-expanded="true">
          <i class="far fa-euro-sign"></i>
          <span class="nav-label">Facturations</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isBillingMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isAutomaticBilling }" v-show="$root.isAuthorized('internal-billing_index')">
            <router-link :to="{ name: 'AutomaticBillingList' }">Facturation automatique</router-link>
          </li>
          <li :class="{ active: isManualBilling }" v-show="$root.isAuthorized('manual-billing_index')">
            <router-link :to="{ name: 'ManualBillingList' }">Facturation manuelle</router-link>
          </li>
          <li :class="{ active: isNotBillableBusiness }" v-show="$root.isAuthorized('not-billable-business_index')">
            <router-link :to="{ name: 'NotBillableBusinessList' }">
              <span class="nav-label">Affaires non facturables</span>
            </router-link>
          </li>
          <li :class="{ active: isPendingFee }" v-show="$root.isAuthorized('location-for-account_index')">
            <router-link :to="{ name: 'PendingFeeList' }">
              <span class="nav-label">Frais à facturer</span>
            </router-link>
          </li>
          <li :class="{ active: isTransportRate }" v-show="$root.isAuthorized('transport-rate_index')">
            <router-link :to="{ name: 'TransportRateList' }">
              <span class="nav-label">Barème transport</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isLocationForAccountMenu }" v-show="$root.isAuthorized('location-for-account_index')">
        <a href="#" aria-expanded="true">
          <i class="far fa-handshake"></i>
          <span class="nav-label">Location pour compte</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isLocationForAccountMenu ? 'in' : null]"
          aria-expanded="true" style>
          <li :class="{ active: isLocationForAccount }">
            <router-link :to="{ name: 'LocationForAccountList' }">
              <span class="nav-label">Suivi des demandes</span>
            </router-link>
          </li>
          <li :class="{ active: isRequestAttribute }">
            <router-link :to="{ name: 'RequestAttributeList' }">
              <span class="nav-label">Attributs de demande</span>
            </router-link>
          </li>
          <li :class="{ active: isFeeLabel }">
            <router-link :to="{ name: 'FeeLabelList' }">
              <span class="nav-label">Libellés de frais</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isComplaint }" v-show="$root.isAuthorized('complaint_index')">
        <router-link :to="{ name: 'ComplaintList' }">
          <i class="far fa-info-square"></i>
          <span class="nav-label">Réclamations</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isAgency }" v-show="$root.isAuthorized('agency_index')">
        <a href="#" aria-expanded="true">
          <i class="far fa-euro-sign"></i>
          <span class="nav-label">Agences</span>
          <span class="fal arrow"></span>
        </a>

        <ul :class="['nav', 'nav-second-level', 'collapse', isAgency ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isAgency }" v-show="$root.isAuthorized('agency_index')">
            <router-link :to="{ name: 'AgencyList' }">
              <span class="nav-label">Agences</span>
            </router-link>
          </li>
          <li :class="{ active: isAgencyGroup }" v-show="$root.isAuthorized('agency_index')">
            <router-link :to="{ name: 'AgencyGroupList' }">
              <span class="nav-label">Groupes d'agences</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isBusiness }" v-show="$root.isAuthorized('business_index')">
        <router-link :to="{ name: 'BusinessList' }">
          <i class="far fa-briefcase"></i>
          <span class="nav-label">Affaires</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isEmployee }" v-show="$root.isAuthorized('employee_index')">
        <router-link :to="{ name: 'EmployeeList' }">
          <i class="far fa-users"></i>
          <span class="nav-label">Employés</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isExports }">
        <router-link :to="{ name: 'Exports' }">
          <i class="fas fa-download"></i>
          <span class="nav-label">Extraction</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isShopMenu }"
        v-show="$root.isAuthorized(['faq_index', 'axiloc-setting_edit', 'popup_edit'], true)">
        <a href="#" aria-expanded="true">
          <i class="far fa-store"></i>
          <span class="nav-label">Boutique</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isShopMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isAxilocSetting }" v-show="$root.isAuthorized('axiloc-setting_edit')">
            <router-link :to="{ name: 'AxilocSettingEdit' }">Paramètres</router-link>
          </li>
          <li :class="{ active: isFeaturedProduct }" v-show="$root.isAuthorized('axiloc-setting_edit')">
            <router-link :to="{ name: 'FeaturedProductEdit' }">Produits à la Une</router-link>
          </li>
          <li :class="{ active: isFaq }" v-show="$root.isAuthorized('faq_index')">
            <router-link :to="{ name: 'FaqList' }">FAQ</router-link>
          </li>
          <li :class="{ active: isTheTeam }" v-show="$root.isAuthorized('theteam_edit')">
            <router-link :to="{ name: 'TheTeamEdit', params: { id: 1 } }">L'équipe</router-link>
          </li>
          <li :class="{ active: isPopup }" v-show="$root.isAuthorized('popup_edit')">
            <router-link :to="{ name: 'PopupEdit', params: { id: 1 } }">Popup</router-link>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('desktop_access') && window_innerWidth > 768"
        :class="{ active: isAdminMenu }" v-show="$root.isAuthorized(
          ['myaxiloc-setting_index', 'user_new', 'user_edit', 'user_delete', 'role-rights_edit'],
          true
        )
          ">
        <a href="#" aria-expanded="true">
          <i class="far fa-cog"></i>
          <span class="nav-label">Administration</span>
          <span class="fal arrow"></span>
        </a>
        <ul :class="['nav', 'nav-second-level', 'collapse', isAdminMenu ? 'in' : null]" aria-expanded="true" style>
          <li :class="{ active: isMyaxilocSetting }" v-show="$root.isAuthorized('myaxiloc-setting_index')">
            <router-link :to="{ name: 'MyaxilocSettingList' }">Paramètres</router-link>
          </li>
          <li :class="{ active: isUser }" v-show="$root.isAuthorized('user_index') &&
            $root.isAuthorized(['user_new', 'user_edit', 'user_delete'], true)
            ">
            <router-link :to="{ name: 'UserList' }">Utilisateurs</router-link>
          </li>
          <li :class="{ active: isRole }" v-show="$root.isAuthorized('role-rights_edit')">
            <router-link :to="{ name: 'RoleAuthorization' }">Rôles</router-link>
          </li>
          <!-- Aperçu des emails transactionnels : outillage de développement, servi par
               Symfony. La route n'existe qu'en environnement dev côté back — l'entrée suit
               la même règle plutôt que de mener à une 404 en production. -->
          <li v-if="mailPreviewUrl">
            <a :href="mailPreviewUrl" target="_blank" rel="noopener">Aperçu des emails</a>
          </li>
        </ul>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('mobile_access') && window_innerWidth <= 768"
        :class="{ active: isHome }">
        <router-link :to="{ name: 'HomeMobile' }" @click.native="hideMobileMenu()">
          <i class="fas fa-th-large"></i>
          <span class="nav-label">Dashboard</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('mobile_access') && window_innerWidth <= 768"
        :class="{ active: isRenting }" v-show="$root.isAuthorized('renting-preparation_index')">
        <router-link :to="{ name: 'RentingPreparationMobileList' }" @click.native="hideMobileMenu()">
          <i class="far fa-long-arrow-right"></i>
          <span class="nav-label">Préparation en attente</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('mobile_access') && window_innerWidth <= 768"
        :class="{ active: isReceptionMobile }" v-show="$root.isAuthorized('business-return_index')">
        <router-link :to="{ name: 'ReceptionMobileList' }" @click.native="hideMobileMenu()">
          <i class="far fa-long-arrow-left"></i>
          <span class="nav-label">Réceptions en attente</span>
        </router-link>
      </li>
      <li v-if="$store.getters['auth/isAuthorized']('mobile_access') && window_innerWidth <= 768"
        :class="{ active: isShipping }" v-show="$root.isAuthorized('shipping_index')">
        <router-link :to="{ name: 'ShippingMobileList' }" @click.native="hideMobileMenu()">
          <i class="far fa-truck"></i>
          <span class="nav-label">Expéditions en attente</span>
        </router-link>
      </li>
      <li
        v-if="$store.getters['auth/isAuthorized']('mobile_access') && window_innerWidth <= 768 && showAddToHomeButton">
        <a href="" @click.prevent="addToHome()">
          <i class="far fa-truck"></i>
          <span class="nav-label">Ajouter à l'écran d'accueil</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { defaultLocale } from "@/traductions/config";

export default {
  name: "Nav",
  data() {
    return {
      links: {
        // Always displayed
        global: [
          {
            id: 0,
            text: "navigation.home",
            page: "/",
          },
        ],
        // Only if authentified
        authentified: [
          {
            id: 2,
            text: "navigation.logout",
            page: "/security/logout",
          },
          {
            id: 3,
            text: "navigation.profile",
            page: "/security/profile",
          },
          {
            id: 4,
            text: "navigation.authorizations",
            page: "/role/authorization",
            authorization: "role-rights_edit",
          },
          {
            id: 5,
            text: "navigation.users",
            page: "/user",
            authorization: "user_index",
          },
        ],
      },
      window_innerWidth: window.innerWidth,
      deferredPrompt: null,
      showAddToHomeButton: false,
    };
  },
  computed: {
    // Lien vers l'écran d'aperçu des emails, servi par Symfony. L'hôte est celui du
    // back-office et non celui de l'API : la route est derrière le pare-feu `axiloc`, qui
    // n'est actif que sur ce domaine — depuis 127.0.0.1, elle ne fait que rediriger vers le
    // formulaire de connexion. Vide hors développement, où la route n'existe pas.
    mailPreviewUrl() {
      if (process.env.NODE_ENV !== "development") {
        return null;
      }
      return "https://axiloc.dev.cool/administration/mails";
    },
    isHome() {
      let routes = ["Home"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isRenting() {
      let routes = ["RentingList", "RentingNew", "RentingEdit", "RentingDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isRentingPreparation() {
      let routes = ["RentingPreparationList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isExchange() {
      return this.$route.name === "ExchangeList";
    },
    isBusinessReturn() {
      let routes = ["BusinessReturnList", "BusinessReturnEdit", "BusinessReturnDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isReceptionMobile() {
      let routes = [
        "ReceptionMobileList",
        "BusinessReturnMobileList",
        "BusinessReturnMobileDetail",
        "WarehouseTransferMobileDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isTransfer() {
      let routes = ["TransferList", "TransferEdit", "TransferDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isShipping() {
      let routes = ["ShippingList", "ShippingNew", "ShippingEdit", "ShippingDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isStorageMenu() {
      return this.isWarehouse || this.isStorageZone || this.isStorageEnvironment || this.isWarehouseTransfer;
    },
    isWarehouse() {
      let routes = ["WarehouseList", "WarehouseNew", "WarehouseEdit", "WarehouseDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isWarehouseTransfer() {
      let routes = ["WarehouseTransferList", "WarehouseTransferForm", "WarehouseTransferDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isStorageZone() {
      let routes = ["StorageZoneList", "StorageZoneNew", "StorageZoneEdit", "StorageZoneDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isStorageEnvironment() {
      let routes = [
        "StorageEnvironmentList",
        "StorageEnvironmentNew",
        "StorageEnvironmentEdit",
        "StorageEnvironmentDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isShopMenu(){
      return this.isFaq || this.isAxilocSetting || this.isPopup || this.isTheTeam || this.isFeaturedProduct;
    },
    isCompanyMenu() {
      return this.isCompany || this.isCompanyContact || this.isCompanyGroup;
    },
    isCompany() {
      let routes = ["CompanyList", "CompanyNew", "CompanyEdit", "CompanyDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isCompanyContact() {
      let routes = [
        "CompanyContactList",
        "CompanyContactNew",
        "CompanyContactEdit",
        "CompanyContactDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isCompanyGroup() {
      let routes = [
        "CompanyGroupList",
        "CompanyGroupNew",
        "CompanyGroupEdit",
        "CompanyGroupDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isEquipmentMenu() {
      return (
        this.isReference ||
        this.isProduct ||
        this.isParentProduct ||
        this.isSparePart ||
        this.isAgencyRentingsList
      );
    },
    isProduct() {
      let routes = ["ProductList", "ProductNew", "ProductEdit", "ProductDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isParentProduct() {
      let routes = ["ParentProductList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isReference() {
      let routes = ["ReferenceList", "ReferenceNew", "ReferenceEdit", "ReferenceDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isOverdueMaintenanceReference() {
      let routes = ["OverdueMaintenanceReferenceList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isAgencyRentingsList() {
      let routes = ["AgencyRentingsList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isSparePart() {
      let routes = ["SparePartList", "SparePartNew", "SparePartEdit", "SparePartDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isExternalMaintenance() {
      let routes = [
        "ExternalMaintenanceList",
        "ExternalMaintenanceNew",
        "ExternalMaintenanceEdit",
        "ExternalMaintenanceDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isComplaint() {
      let routes = ["ComplaintList", "ComplaintNew", "ComplaintEdit", "ComplaintDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isAgency() {
      let routes = ["AgencyList", "AgencyNew", "AgencyEdit", "AgencyDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isAgencyGroup(){
      let routes = [ "AgencyGroupList", "AgencyGroupNew", "AgencyGroupEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isBusiness() {
      let routes = ["BusinessList", "BusinessNew", "BusinessEdit", "BusinessDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isEmployee() {
      let routes = ["EmployeeList", "EmployeeNew", "EmployeeEdit", "EmployeeDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isExports() {
      let routes = ["Exports"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isAxilocSetting() {
      let routes = [
        "AxilocSettingList",
        "AxilocSettingNew",
        "AxilocSettingEdit",
        "AxilocSettingDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isFeaturedProduct() {
      let routes = ["FeaturedProductEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isFaq() {
      let routes = ["FaqList", "FaqNew", "FaqEdit", "FaqDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isTheTeam() {
      let routes = ["TheTeamList", "TheTeamNew", "TheTeamEdit", "TheTeamDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isPopup() {
      let routes = ["PopupEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isAdminMenu() {
      return this.isMyaxilocSetting || this.isUser || this.idRole;
    },
    isMyaxilocSetting() {
      let routes = [
        "MyaxilocSettingList",
        "MyaxilocSettingNew",
        "MyaxilocSettingEdit",
        "MyaxilocSettingDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isUser() {
      let routes = ["UserList", "UserNew", "UserEdit", "UserDetail", "UserAuthorization"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isRole() {
      let routes = ["RoleAuthorization"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isBillingMenu() {
      return this.isAutomaticBilling || this.isManualBilling || this.isNotBillableBusiness
        || this.isTransportRate || this.isPendingFee;
    },
    isAutomaticBilling() {
      let routes = ["AutomaticBillingList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isManualBilling() {
      let routes = [
        "ManualBillingList",
        "ManualBillingNew",
        "ManualBillingEdit",
        "ManualBillingDetail",
      ];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isNotBillableBusiness() {
      let routes = ["NotBillableBusinessList"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isTransportRate() {
      let routes = ["TransportRateList", "TransportRateNew", "TransportRateEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isPendingFee() {
      return "PendingFeeList" === this.$route.name;
    },
    isRequestAttribute() {
      let routes = ["RequestAttributeList", "RequestAttributeNew", "RequestAttributeEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isFeeLabel() {
      let routes = ["FeeLabelList", "FeeLabelNew", "FeeLabelEdit"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isLocationForAccount() {
      let routes = ["LocationForAccountList", "LocationForAccountDetail"];
      return routes.indexOf(this.$route.name) >= 0;
    },
    isLocationForAccountMenu() {
      return this.isLocationForAccount || this.isRequestAttribute || this.isFeeLabel;
    }
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      this.showButton     = true
    })
  },
  updated() {
    // MetisMenu
    var sideMenu = $("#side-menu").metisMenu();

    sideMenu.on("shown.metisMenu", function (e) {
      fix_height();
    });
  },
  methods: {
    hideMobileMenu() {
      this.$emit("hideMobileMenu");
    },
    async addToHome() {
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt()
      const { outcome } = await this.deferredPrompt.userChoice
      if (outcome === 'accepted') {
        console.log('App ajoutée à l\'écran d\'accueil')
      } else {
        console.log('Ajout annulé')
      }
      this.deferredPrompt = null
      this.showButton = false
    }
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.nav-header {
  background: #ffffff;
  border-right: 1px solid #ddd;
  padding: 15px 25px;
  margin-bottom: 60px;
  height: 70px;

  img {
    display: block;
    max-width: 100%;
    max-height: 40px;
  }
}

.nav>li.active {
  background-color: $primary-darker;
}

.navbar-default {
  font-size: 13px;

  .nav>li>a:hover,
  .navbar-default .nav>li>a:focus {
    background-color: $primary-darker;
  }
}

.metismenu .fal.arrow:before {
  content: "\f104";
}

.metismenu .active>a>.fal.arrow:before {
  content: "\f107";
}

.metismenu>li>a {
  padding-top: 16px;
  padding-bottom: 16px;

  i {
    min-width: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Nav.vue